import css from "./LogoutModal.module.css";
import { useDispatch } from "react-redux";
import { logOut } from "../../../redux/auth/operations.js";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../utils/showToast.js";
import ModalCloseIcon from "../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

export default function LogoutModal({ onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    await dispatch(logOut())
      .unwrap()
      .then(() => {
        navigate("/login");
      })
      .catch(() => {
        showToast("Щось сталося, спробуйте ще раз", "error");
      });
    onClose();
  };

  return (
    <div className={css.logoutBox}>
      <ModalCloseIcon onClose={onClose} />
      <h3>Вихід</h3>
      <p>Ви дійсно бажаєте вийти?</p>
      <div className={css.btnBox}>
        <button type="button" className={css.btn} onClick={handleLogOut}>
          Вихід
        </button>
        <button type="button" className={css.btn} onClick={onClose}>
          Відміна
        </button>
      </div>
    </div>
  );
}
